// @core/api/endpoints/billing/update_billing_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateBillingAccountRequest,
  UpdateBillingAccountResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Update billing account
 * Updates billing account information such as contact details, addresses, and tax information. Use specific endpoints for payment methods.
 */
export async function UpdateBillingAccount(
  id: string,
  data: UpdateBillingAccountRequest,
  options?: RequestOptions
): Promise<UpdateBillingAccountResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.patch<UpdateBillingAccountResponse>(requestPath, data, requestOptions);
}
